module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("Добавить квартиру")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'block-details',
        params: {
          block_id: _vm.$route.params.block_id
        }
      }
    }
  }, [_vm._v("← Назад к Квартирам")])], 1), _vm._v(" "), _c('apartment-add-form', {
    attrs: {
      "block": +_vm.$route.params.block_id
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb214c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/apartment/ApartmentAdd.vue
// module id = 591
// module chunks = 0